import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { blue, green, red, yellow } from '@mui/material/colors';
import { USER_ANNOUNCEMENT_TYPES } from '@a1/shared';

const USER_ANNOUNCEMENT_TYPES_WITH_UI = [
  { label: 'Alerts', color: red[600], border: red[100], Icon: ReportProblemOutlinedIcon, value: USER_ANNOUNCEMENT_TYPES.Alerts },
  { label: 'Information', color: blue[600], border: blue[100], Icon: InfoOutlinedIcon, value: USER_ANNOUNCEMENT_TYPES.Info },
  { label: 'Warning', color: yellow[900], border: yellow[600], Icon: GppBadOutlinedIcon, value: USER_ANNOUNCEMENT_TYPES.Warning },
  { label: 'Announcement', color: green[600], border: green[100], Icon: CampaignOutlinedIcon, value: USER_ANNOUNCEMENT_TYPES.Announcement }
];

// eslint-disable-next-line import/prefer-default-export
export { USER_ANNOUNCEMENT_TYPES_WITH_UI };
